module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-BoldSemiExt.73274e7.eot";